import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Card, CardContent, Divider, Tab, Tabs } from "@material-ui/core";
import _ from "lodash";
import SectionTab from "constants/SectionTab";
import NoData from "modules3/components/no-data";
import { ListViewSkeleton } from "common/ui/skeleton-ui";
import { ListItemList } from "../components";
import { ShowMore } from "modules2/components";
import { scrollToMainContent } from "common/ui/utils";
import container from "./History.container";

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: 345,
    marginBottom: 10,
    background: theme.palette.paperColor,
    color: theme.palette.textColor,
  },
  tabRoot: {
    color: theme.palette.textColor1,
    "& .MuiTabs-indicator": {
      backgroundColor: theme.palette.pink,
    },
  },
  tabButton: {
    color: theme.palette.textColor,
    fontFamily: "Arial",
    minHeight: 48,
    "& .MuiTab-wrapper": {
      alignItems: "initial",
      flexDirection: "row",
    },
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-around",
    marginTop: 10,
  },
  circularProgress: {
    position: "relative",
    textAlign: "center",
  },
}));

const tabList = [
  {
    id: 0,
    name: SectionTab.RadioFavourite,
  },
  {
    id: 1,
    name: SectionTab.RadioHistory,
  },
];

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`nav-tabpanel-${index}`}
      aria-labelledby={`nav-tab-${index}`}
      {...other}
    >
      {value === index && <Box style={{ padding: 0 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const History = (props) => {
  const classes = useStyles();
  // const theme = useTheme();
  // const matchesXS = useMediaQuery(theme.breakpoints.down('xs'));
  const {
    userState: { firstName },
    podcastState: { loading, genresPodcasts, mostPopular },
    userHistoryPodcastState: {
      history,
      historyPodcastIds,
      heartedPodcastIds,
      heartsNext,
      historyNext,
      historyLoading,
      heartedLoading,
    },
    onSetCurrentTab,
    onViewPodCastStart,
    onFetchPodCastEpisode,
    // onFetchApplePodcastEpisode,
    // onFetchListenNotesPodcastEpisode,
    onGetNextFavoriteStart,
    onGetNextHistoryStart,
    onFavouritePodcast,
    onRemoveFavoritePodcast,
    onDeleteHistoryPodcast,
    onShowSnackbarNotification,
    onSetCurrentViewdPodPlaylist,
  } = props;
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const onListItemClick = (tab, uuid) => {
    onSetCurrentTab(tab);
    onViewPodCastStart(uuid);
    onFetchPodCastEpisode(uuid);
    onSetCurrentViewdPodPlaylist(uuid);
    /*const id = uuid.toString();
    if (id.length < 15 && id.startsWith('p')) {
      onFetchPodCastEpisode(uuid);
    } else if (id.length <= 15) {
      onFetchApplePodcastEpisode(uuid);
    } else {
      onFetchListenNotesPodcastEpisode(uuid);
    }*/
    scrollToMainContent();
  };

  const onDeleteClick = (id) => {
    switch (value) {
      case 0:
        onShowSnackbarNotification(`Podcast Unhearted 😢`);
        onRemoveFavoritePodcast(id);
        break;
      case 1:
        onShowSnackbarNotification(`Podcast deleted from history 😢`);
        onDeleteHistoryPodcast(id);
        break;
      default:
        console.warn("Unknown case: ", value);
        break;
    }
  };

  const onFavouriteClick = (id) => {
    if (heartedPodcastIds.some((radio) => radio === id)) {
      onShowSnackbarNotification(`Podcast Un-hearted 😢`);
      onRemoveFavoritePodcast(id);
    } else {
      onShowSnackbarNotification(`Podcast Hearted ❤️`);
      onFavouritePodcast(id);
    }
  };

  const displayList = (skeletonLoading) => {
    let nextValue;
    let message;
    let items = [];

    let loading;

    switch (value) {
      case 0:
        loading = heartedLoading;
        nextValue = heartsNext;
        items = heartedPodcastIds;
        message = `Hey ${
          firstName ? firstName : "there"
        }, you don't have any hearted yet.`;
        break;
      case 1:
        loading = historyLoading;
        nextValue = historyNext;
        items = historyPodcastIds;
        message = `Hey ${
          firstName ? firstName : "there"
        }, you don't have any history yet.`;
        break;
      default:
        console.warn("Unknown case: ", value);
        break;
    }

    if (skeletonLoading || loading) {
      return [...Array(3)].map((_, idx) => {
        return <ListViewSkeleton key={idx} />;
      });
    }

    return items.length ? (
      items
        .map((id) => history[id])
        .filter((x) => !_.isEmpty(x) && !_.isNil(x))
        .reverse() // TODO: remove[takes hit on the performance]
        .slice(0, nextValue) // TODO: remove[takes hit on the performance]
        .map((podcast, index) => {
          return (
            <ListItemList
              editable
              hearted={!tabList.findIndex((obj) => obj.id === value)}
              key={podcast.id}
              sectionTab={SectionTab.PodCastDetail}
              podcastid={podcast.id.toString()}
              image={
                podcast.image ??
                podcast.artworkUrl600 ??
                podcast.artworkUrl100 ??
                "null"
              }
              title={
                podcast.text ??
                podcast.title ??
                podcast.name ??
                podcast.trackName
              }
              subtitle={
                podcast.subtext ?? podcast.country ?? podcast.releaseDate
              }
              data={podcast}
              onListItemClick={onListItemClick}
              onDeleteClick={onDeleteClick}
              onFavouriteClick={onFavouriteClick}
            />
          );
        })
    ) : (
      <NoData
        loading={skeletonLoading}
        message={message}
        mostPopular={mostPopular}
        podcasts={genresPodcasts}
        onSetCurrentTab={onSetCurrentTab}
        onListItemClick={onListItemClick}
        onDeleteClick={onDeleteClick}
        onFavouriteClick={onFavouriteClick}
      />
    );
  };

  useEffect(() => {
    moreOnCurrentTab();
  }, [heartsNext, historyNext]);

  const moreOnCurrentTab = () => {
    switch (value) {
      case 0:
        return heartedPodcastIds.length > heartsNext;
      case 1:
        return historyPodcastIds.length > historyNext;
      default:
        console.warn("Unknown case:", value);
        return false;
    }
  };

  const onClickSeeMore = () => {
    if (!moreOnCurrentTab()) {
      return;
    }

    switch (value) {
      case 0:
        return onGetNextFavoriteStart(heartsNext, 3);
      case 1:
        return onGetNextHistoryStart(historyNext, 3);
      default:
        console.warn("Unknown case:", value);
        return;
    }
  };

  return (
    <Card className={classes.root}>
      <CardContent style={{ padding: 0, minHeight: 485 }}>
        <Tabs
          value={value}
          onChange={handleChange}
          className={classes.tabRoot}
          variant={"fullWidth"}
        >
          <Tab
            label="Favorite"
            className={classes.tabButton}
            {...a11yProps(
              tabList.findIndex((obj) => obj.name === SectionTab.RadioFavourite)
            )}
          />
          <Tab
            label="History"
            className={classes.tabButton}
            {...a11yProps(
              tabList.findIndex((obj) => obj.name === SectionTab.RadioHistory)
            )}
          />
        </Tabs>
        <Divider />
        {tabList.map((item, index) => {
          return (
            <TabPanel value={value} index={index} key={index}>
              <div className={classes.container}>{displayList(loading)}</div>
            </TabPanel>
          );
        })}
        {moreOnCurrentTab() && <ShowMore nextRadioList={onClickSeeMore} />}
      </CardContent>
    </Card>
  );
};

export default container(History);
